import { apiClient } from '@/lib/api'

export type FavoriteProduct = {
  product_id: number
  name: string
  sku?: string | null
  unit_price?: number | null
  promotional_unit_price?: number | null
  promo_starts_at?: string | null
  promo_ends_at?: string | null
  show_price_on_shop?: boolean
  category_storefront_selling_enabled?: boolean
  category_storefront_show_price?: boolean
  shop_sales_mode?: string | null
  product_type?: string | null
  website_slug?: string | null
  image_path?: string | null
  favorited_at?: string
  /** False when inactive or not listed on the website. */
  is_available?: boolean
}

export const productFavoriteService = {
  getMyFavoriteIds: async () => {
    return apiClient.get<{ success: boolean; data: { product_ids: number[] } }>(
      '/product-favorites/ids',
    )
  },

  getMyFavorites: async () => {
    return apiClient.get<{ success: boolean; data: FavoriteProduct[] }>('/product-favorites')
  },

  addFavorite: async (productId: number) => {
    return apiClient.post<{ success: boolean; data: { product_id: number; favorited: boolean } }>(
      `/product-favorites/${productId}`,
    )
  },

  removeFavorite: async (productId: number) => {
    return apiClient.delete<{ success: boolean; data: { product_id: number; favorited: boolean } }>(
      `/product-favorites/${productId}`,
    )
  },
}
